module.exports = __webpack_public_path__ + "packages-background.jpg?ebc3ca4c3101f686ef7eb32645c74886";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/packages-background.jpg
// module id = 306
// module chunks = 0